import styled from 'styled-components'
import L from '../L'

const StyledMobileIcon = styled(L).attrs({
  display: { xx: 'grid', md: 'none' },
  ai: 'center',
  position: 'relative',
  selectable: true,
})`
  transition: ${props => props.theme.mixins.transition(['color'])};

  &:after {
    content: '';
    position: absolute;
    bottom: -8px;
    left: 0;
    right: 0;
    margin-left: calc(-50% + 1px);
    margin-right: auto;
    width: 50px;
    height: 3px;
    z-index: 1;
    opacity: 0;
    visibility: hidden;
    background-color: ${props => props.theme.palette.primary.main};
    transition: ${props => props.theme.mixins.transition(['opacity', 'visibility'])};
  }

  ${props =>
    props.active
      ? `
      color: ${props => props.theme.palette.primary.main};
  
      &:after {
        opacity: 1;
        visibility: visible;
      }
    `
      : ``}
`

const navMenuStyles = theme => ({
  navMenu: {
    cursor: 'pointer',
    position: 'relative',
    [`@media(min-width: 1024px)`]: {
      zIndex: 1,
    },
  },
  navMenuHead: {
    display: 'inline-grid',
    gridGap: '15px',
    gridAutoFlow: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    position: 'relative',
    minHeight: 40,
    ...theme.mixins.padding([1, 1.5]),
    userSelect: 'none',
    borderLeft: theme.globals.border,
    borderRight: theme.globals.border,
  },
  navMenuOpen: {
    zIndex: theme.zIndex.max,
  },
  navMenuHeadIcon: {
    width: 0,
    height: 0,
    borderLeft: '5px solid transparent',
    borderRight: '5px solid transparent',
    borderTop: `5px solid ${theme.palette.secondary.lightish}`,
    transition: theme.mixins.transition(['border-top']),
    '&.active': {
      transform: 'rotate(-180deg)',
    },
  },
  l_support: {
    marginTop: theme.spacing(1),
    padding: `${theme.spacing(2)}px ${theme.spacing(1.5)}px`,
    ...theme.mixins.gridRows(theme.spacing(2)),
    backgroundColor: theme.palette.common.gray.lightest,
    outline: 'none',
  },
  supportItem: {
    ...theme.mixins.gridColumns(theme.spacing(1)),
    gridTemplateColumns: 'max-content',
    cursor: 'pointer',
  },
  supportItemIcon: {
    width: 20,
    height: 22,
    ...theme.mixins.flexXCenter,
    flexDirection: 'row',
    alignItems: 'flex-start',
    '& svg': {
      ...theme.mixins.responsiveImage,
    },
  },
  supportItemLabel: {
    marginBottom: theme.spacing(0.5),
  },
})

const styledMenuItemStyles = theme => ({
  root: {
    padding: `${theme.spacing(0.5)}px ${theme.spacing(1)}px`,
    maxWidth: '100%',
    width: 1000,
    color: theme.palette.text.secondaryHueLightish,
    ...theme.typography.subtitle,
    whiteSpace: 'wrap !important',
    position: 'relative',
    '&:focus': {
      '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
        color: theme.palette.common.white,
      },
    },
    '&:before': {
      content: '""',
      position: 'absolute',
      left: 0,
      top: 0,
      width: 3,
      height: '100%',
      backgroundColor: theme.palette.primary.main,
      zIndex: 1,
      opacity: 0,
      visibility: 'hidden',
      transition: theme.mixins.transition(['opacity', 'visibility']),
    },
    '&.active': {
      '&:before': {
        opacity: 1,
        visibility: 'visible',
      },
    },
  },
})

export { navMenuStyles, StyledMobileIcon, styledMenuItemStyles }
